module.exports = __webpack_public_path__ + "static/data-and-analytics-de2100442d8c2c5f7ef4cb8450002a67.jpg";